// possibly add this:
// function createResourceRoute(base: string) {
//   return (resource: string) => base.concat('/', resource);
// }
// const resource = createResourceRoute('journey');

export const journeyRoutes = {
  root: '/journeys',
  journey: (token: string) => `/journeys/${token}` as const,
} as const;
